var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoWes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "aj7g8kdm5a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15380",
    transform: "translate(597 1477)",
    style: {
      fill: "#ff1010",
      opacity: 0.43
    },
    d: "M0 0h120v120H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 676",
    transform: "translate(-597 -1477)",
    style: {
      clipPath: "url(#aj7g8kdm5a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 720"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59448",
    d: "M28.25 64.4.75 55.24V22.028l27.5 9.161z",
    transform: "translate(601.25 1520.234)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 57",
    transform: "rotate(6.02 -14624.302 6556.06)",
    style: {
      strokeLinecap: "round",
      stroke: "#fff",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M5.84 1.281 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59449",
    d: "m12 64.4 27.5-9.16V22.028L12 31.189z",
    transform: "translate(617.504 1520.234)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59450",
    d: "M28.25 18.077.75 27.739l27.5 9.161 27.5-9.161z",
    transform: "translate(601.25 1514.523)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59451",
    d: "M6.373 44.092V29.575l26.959-9.6",
    transform: "translate(609.376 1517.265)",
    style: {
      strokeLinecap: "round",
      stroke: "#fff",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 721"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59452",
    d: "m50.741 64.4-27.5-9.161V22.028l27.5 9.161z",
    transform: "translate(633.76 1520.234)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 58",
    transform: "rotate(6.02 -14596.815 7078.442)",
    style: {
      strokeLinecap: "round",
      stroke: "#fff",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M5.84 1.281 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59453",
    d: "m34.486 64.4 27.5-9.161V22.028l-27.5 9.161z",
    transform: "translate(650.014 1520.234)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59454",
    d: "m50.741 18.077-27.5 9.662 27.5 9.161 27.5-9.161z",
    transform: "translate(633.76 1514.523)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59455",
    d: "M28.863 44.092V29.575l26.959-9.6",
    transform: "translate(641.887 1517.265)",
    style: {
      strokeLinecap: "round",
      stroke: "#fff",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59456",
    d: "M39.5 47.289 12 37.611V4.7l27.5 9.161z",
    transform: "translate(617.504 1494.961)",
    style: {
      stroke: "#4cbbb8",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 59",
    transform: "rotate(6.02 -14205.993 6795.954)",
    style: {
      stroke: "#4cbbb8",
      strokeLinecap: "round",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M5.84 1.281 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59457",
    d: "m23.241 47.33 27.5-9.662V4.7l-27.5 9.161z",
    transform: "translate(633.759 1494.961)",
    style: {
      stroke: "#4cbbb8",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59458",
    d: "M39.5.75 12 10.412l27.5 9.161L67 10.412z",
    transform: "translate(617.504 1489.25)",
    style: {
      stroke: "#4cbbb8",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59459",
    d: "M17.618 26.765V12.248l26.959-9.6",
    transform: "translate(625.632 1491.992)",
    style: {
      stroke: "#4cbbb8",
      strokeLinecap: "round",
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWes);
export default __webpack_public_path__ + "static/media/ico_wes.a9787796658c9e6626f199de3d4c0ae5.svg";
export { ForwardRef as ReactComponent };